import { Component, OnInit, Directive, Input } from '@angular/core';
import {
  UserService,
  LoadingService,
  AuthenticationService
} from '../../_shared/services';
import {
  FormGroup,
  FormGroupDirective,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import {
  MatTableDataSource,
  MatSort,
  Sort,
  ErrorStateMatcher,
  MatSnackBar
} from '@angular/material';
import {
  APIResponse,
  User,
  Administrator,
  Division,
  EqualValidator,
  regExps,
  MyErrorStateMatcher,
  errorMessages,
  AddUserData,
  EditUserData,
  CustomSnackbarComponent,
  SnackBarContent
} from '../../_shared';
import { Granule } from '../../config';

@Component({
  selector: 'app-administrator',
  templateUrl: './administrator.component.html',
  styleUrls: [
    '../_css/user-management.component.css',
    '../../../assets/css/core-navbar.css',
    '../_css/user-management-list.component.css',
    '../_css/user-management-mobile-responsive.css'
  ]
})
export class AdministratorComponent implements OnInit {
  private users = new Array<Administrator>();
  private usersDisplayed: Administrator[];
  private selectedPage: number = 1;
  private selectedUser: User;
  private currentUser: User;
  private userCategories: Object;
  private searchKey: string;
  private limit = 10;
  private isActiveToggled: boolean;
  private isDivisionToggled = false;
  private isCategoryLoaded = false;
  private divisions = new Array<Division>();
  private selectedDivision = 'All Division';
  private passwordRequired: boolean = false;
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;
  private newUserForm: FormGroup;
  private editUserForm: FormGroup;
  private errorMatcher = new MyErrorStateMatcher();
  private errors = errorMessages;
  private toggleDropdown: Array<boolean> = new Array<boolean>(3);

  constructor(
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private granule: Granule,
    private fb: FormBuilder,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.initForms();
    this.authenticationService.userInfo.subscribe(userInfo => {
      this.currentUser = userInfo;
      if (userInfo.current_role !== null) {
        this.selectedUser = null;
        this.initDivision();
        this.initUsers();
        this.load(false);
      }
    });
  }

  initForms() {
    // constructor + form Validator for New User
    this.newUserForm = this.fb.group(
      {
        fullnameControl: [
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(20)
          ])
        ],
        emailControl: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(regExps.email)
          ])
        ],
        usernameControl: [
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(20)
          ])
        ],
        passwordControl: ['', Validators.pattern(regExps.password)],
        confirmPasswordControl: ['']
      },
      {
        validator: EqualValidator.Match(
          'passwordControl',
          'confirmPasswordControl'
        )
      }
    );
    // constructor + form Validator for Edit User
    this.editUserForm = this.fb.group({
      fullnameControl: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20)
        ])
      ],
      emailControl: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(regExps.email)
        ])
      ],
      usernameControl: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20)
        ])
      ]
    });
  }

  searchUser() {
    if (this.searchKey === '') {
      this.changeDivisionDisplayed(this.selectedDivision);
    } else {
      let search = this.searchKey.toLowerCase();
      this.usersDisplayed = this.users.filter(
        u =>
          u.fullname.toLowerCase().includes(search) ||
          u.username.toLowerCase().includes(search) ||
          u.email.toLowerCase().includes(search) ||
          u.account_status.toLowerCase().includes(search)
      );
    }
  }

  addUser() {
    this.load(true);
    const formModel = this.newUserForm.value;

    let user: AddUserData = {
      fullname: formModel.fullnameControl,
      email: formModel.emailControl,
      username: formModel.usernameControl,
      phone: null,
      company_name: null,
      password: formModel.passwordControl,
      password_confirmation: formModel.confirmPasswordControl,
      profile_picture: null,
      account_status: 'Active',
      account_type: 'Admins'
    };

    this.userService.addUser(user).subscribe(
      res => {
        // this.registerFormErrorMessages = res.errors;
        // this.submitSuccess = res.success;
        console.log('VALUE RECEIVED: ', res);
      },
      x => {
        console.log('ERROR: ' + x);
      },
      () => {
        this.initUsers();
        this.load(false);
        // if (this.submitSuccess === true) {
        //   this.registerForm.reset();
        //   this.message = 'Successfully Create New Account';
        //   $('#submitNotification').modal('show');
        // } else {
        //   console.log(this.registerFormErrorMessages);
        // }
      }
    );
  }

  dropdownControl(value: number) {
    for (let i = 0; i < 3; i++) {
      if (i === value) {
        // if the array number match with value from function, reverse the bool value to toggle
        this.toggleDropdown[i] = !this.toggleDropdown[i];
      } else {
        // other than that, set to false to close dropdown
        this.toggleDropdown[i] = false;
      }
    }
  }

  editUser() {
    this.load(true);
    const formModel = this.editUserForm.value;

    let status = '';

    if (this.isActiveToggled) {
      status = 'Active';
    } else {
      status = 'Inactive';
    }

    let user: EditUserData = {
      id: this.selectedUser._id,
      fullname: formModel.fullnameControl,
      email: formModel.emailControl,
      username: formModel.usernameControl,
      phone: null,
      company_name: null,
      profile_picture: null,
      account_status: status
    };

    console.log(user);

    this.userService.editUser(user).subscribe(
      res => {
        // this.registerFormErrorMessages = res.errors;
        // this.submitSuccess = res.success;
        console.log('VALUE RECEIVED: ', res);
      },
      x => {
        console.log('ERROR: ' + x);
      },
      () => {
        this.initUsers();
        this.load(false);
        // if (this.submitSuccess === true) {
        //   this.registerForm.reset();
        //   this.message = 'Successfully Create New Account';
        //   $('#submitNotification').modal('show');
        // } else {
        //   console.log(this.registerFormErrorMessages);
        // }
      }
    );
  }

  populateEditUserForm(selectedUser: User) {
    this.selectedUser = selectedUser;
    this.editUserForm.reset({
      fullnameControl: selectedUser.fullname,
      emailControl: selectedUser.email,
      usernameControl: selectedUser.username
    });
    if (selectedUser.account_status == 'Active') {
      this.isActiveToggled = true;
    } else {
      this.isActiveToggled = false;
    }
  }

  initUsers() {
    this.userService
      .getUsers('admins')
      .subscribe((res: APIResponse<any, any>) => {
        this.users = res.data;
        this.usersDisplayed = res.data;
      });
  }

  initDivision() {
    this.userService.getDivision().subscribe(
      (res: APIResponse<any, any>) => {
        this.divisions = res.data;
      },
      x => {
        /* this function is executed when there's an ERROR */
        console.log('ERROR: ' + x);
      },
      () => {
        /* this function is executed when the observable ends (completes) its stream */
      }
    );
  }

  dismissNewAccount() {
    console.log(this.newUserForm);
    this.newUserForm.reset({
      fullnameControl: '',
      emailControl: '',
      usernameControl: '',
      passwordControl: '',
      confirmPasswordControl: ''
    });
  }

  toggleStatus() {
    this.isActiveToggled = !this.isActiveToggled;
    this.editUserForm.markAsDirty();
  }

  divisionToggle(event: any) {
    this.isDivisionToggled = !this.isDivisionToggled;
  }

  selectUser(user: User) {
    this.selectedUser = user;
  }

  sortData(sort: Sort) {
    const data = this.usersDisplayed.slice();
    if (!sort.active || sort.direction == '') {
      this.usersDisplayed = data;
      return;
    }

    this.usersDisplayed = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'account':
          return this.compare(
            a.fullname.toLowerCase(),
            b.fullname.toLowerCase(),
            isAsc
          );
        case 'username':
          return this.compare(
            a.username.toLowerCase(),
            b.username.toLowerCase(),
            isAsc
          );
        case 'lastLogin':
          if (!a.last_login) {
            return 1;
          } else if (!b.last_login) {
            return -1;
          } else {
            return this.compare(a.last_login, b.last_login, isAsc);
          }
        case 'division':
          if (!a.account_category.division_name) {
            return 1;
          } else if (!b.account_category.division_name) {
            return -1;
          } else {
            return this.compare(
              a.account_category.division_name.toLowerCase(),
              b.account_category.division_name.toLowerCase(),
              isAsc
            );
          }
        case 'status':
          return this.compare(
            a.account_status.toLowerCase(),
            b.account_status.toLowerCase(),
            isAsc
          );
        default:
          return 0;
      }
    });
  }

  compare(a: any, b: any, isAsc: any) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filterDivision(division: Division) {
    this.changeDivisionDisplayed(division.name);
  }

  changeDivisionDisplayed(name: string) {
    this.selectedDivision = name;

    if (name === 'All Division') {
      this.usersDisplayed = this.users;
    } else {
      this.usersDisplayed = this.users.filter(
        u => u.account_category.division_name === name
      );
    }
  }

  getSelectedUserCategories(user: User) {
    this.selectUser(user);
    this.isCategoryLoaded = false;

    setTimeout(() => {
      let payload = JSON.stringify(this.selectedUser._id);
      this.userService.getUserCategories(payload).subscribe(res => {
        this.userCategories = res.data;
        this.isCategoryLoaded = true;
      });
    }, 50);
  }

  deleteUser() {
    let payload = JSON.stringify(this.selectedUser._id);
    this.userService.deleteUser(payload).subscribe(res => {
      if (res.data) {
        let data: SnackBarContent = {
          type: 'success',
          message: 'User has been deleted'
        };
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
          data: data,
          duration: 5000
        });
      } else {
        let data: SnackBarContent = {
          type: 'error',
          message: 'Something went wrong'
        };
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
          data: data,
          duration: 5000
        });
      }
    });
  }

  changeLimit(value: number) {
    this.limit = value;
  }

  changePage(value: number) {
    this.selectedPage = value;
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/user-management/administrator/administrator.component.ts